import type { Customer } from '@brighterly/lib-core-types/customer/interfaces'
import type { KidInCustomer } from '@brighterly/lib-core-types/kid/interfaces'
import type { DisciplineInKid } from '@brighterly/lib-core-types/discipline/interfaces'

import { Discipline } from '@brighterly/lib-core-types/discipline/enums'

const getDiscipline = (disciplines: Discipline[]): Discipline => {
  if (disciplines.includes(Discipline.ELA) && !disciplines.includes(Discipline.Math)) {
    return Discipline.ELA
  } else {
    return Discipline.Math
  }
}

export const getHomePageRoute = (customer: Customer): string | null => {
  const kid: KidInCustomer | null = customer?.kids?.[0] || null
  const kidId: number | null = kid?.id || null
  const disciplinesInKid: DisciplineInKid[] = kid?.disciplines || []
  const disciplines: Discipline[] = disciplinesInKid.map(disciplineInKid => disciplineInKid.code)
  const discipline: Discipline = getDiscipline(disciplines)
  const disciplineRoute = discipline.toLowerCase()

  return kidId ? `/kids/${kidId}/${disciplineRoute}` : null
}
